import { addBooleanParameter } from "@ovh-ui/common/component-utils";

export default class {
    /* @ngInject */
    constructor ($attrs, ouiFormActionsConfiguration) {
        this.$attrs = $attrs;
        this.config = ouiFormActionsConfiguration;
    }

    $onInit () {
        this.processTranslations();

        addBooleanParameter(this, "disabled");
    }

    processTranslations () {
        this.translations = Object.assign({}, this.config.translations);

        if (angular.isUndefined(this.submitText)) {
            this.submitText = this.translations.submit;
        }

        if (angular.isUndefined(this.cancelText)) {
            this.cancelText = this.translations.cancel;
        }
    }
}
